import { AutomatedReleaseInstructionKind } from '../automated-release/types';
import { ClauseInstructionKind } from '../clauses/constants';

import { RuleInstructionKind } from './constants';

export const filterOutAggregateRules = (instructionKind: string) =>
  instructionKind === ClauseInstructionKind.ADD_CLAUSES ||
  instructionKind === RuleInstructionKind.UPDATE_RULE_VARIATION_OR_ROLLOUT ||
  instructionKind === RuleInstructionKind.STOP_MEASURED_ROLLOUT_ON_RULE ||
  instructionKind === AutomatedReleaseInstructionKind.STOP_AUTOMATED_RELEASE ||
  instructionKind === ClauseInstructionKind.REMOVE_CLAUSES ||
  instructionKind === ClauseInstructionKind.UPDATE_CLAUSE ||
  instructionKind === RuleInstructionKind.UPDATE_RULE_DESCRIPTION ||
  instructionKind === RuleInstructionKind.DISABLE_RULE ||
  instructionKind === RuleInstructionKind.ENABLE_RULE ||
  instructionKind === ClauseInstructionKind.ADD_VALUES_TO_CLAUSE ||
  instructionKind === ClauseInstructionKind.REMOVE_VALUES_FROM_CLAUSE;
